import React, { useEffect, useState } from "react";
import { createStyles, Progress } from "@mantine/core";
import { Button } from "@jem-open/jem-ui";

const useStyles = createStyles(() => ({
  button: {
    position: "relative",
    transition: "background-color 150ms ease",
  },

  progress: {
    position: "absolute",
    bottom: -1,
    right: -1,
    left: -1,
    top: -1,
    height: "auto",
    backgroundColor: "transparent",
    zIndex: 0,
  },

  label: {
    position: "relative",
    zIndex: 1,
  },
}));

const getButtonText = (
  progress: number,
  loaded: boolean,
  buttonLabel: string
): string => {
  if (progress !== 0) {
    return "Uploading file";
  }
  if (loaded) {
    return "File uploaded";
  }

  return buttonLabel;
};

type ButtonProgressProps = {
  progress: number;
  onClick: () => void;
  disabled: boolean;
  buttonLabel: string;
};

const ButtonProgress: React.FC<ButtonProgressProps> = ({
  progress,
  onClick,
  disabled,
  buttonLabel,
}) => {
  const { classes, theme } = useStyles();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (progress === 100) {
      setLoaded(true);
    }
  }, [progress]);

  return (
    <Button
      id="payslips-modal-upload-btn"
      disabled={disabled}
      variant={loaded ? "approve" : "primary"}
      className={`w-full ${classes.button}`}
      onClick={() => (loaded ? setLoaded(false) : onClick())}
    >
      <div className={classes.label}>
        {getButtonText(progress, loaded, buttonLabel)}
      </div>
      {progress !== 0 && (
        <Progress
          value={progress}
          className={classes.progress}
          color={theme.fn.rgba(theme.colors[theme.primaryColor][2], 0.35)}
          radius="sm"
        />
      )}
    </Button>
  );
};

export default ButtonProgress;
